<div class="flex flex-col gap-1.5">
    @if (label()) {
    <label class="flex items-center gap-1.5 text-md font-semibold text-foreground/80">
        @if (labelIconHtml()) {
        <span class="inline-flex shrink-0 items-center [&_svg]:size-4" [innerHTML]="trustedLabelIcon()"
            aria-hidden="true"></span>
        }
        {{ label() }}
        @if (required()) {
        <span class="text-brand-studio" aria-hidden="true">*</span>
        }
    </label>
    }
    <ng-content />
    @if (hint()) {
    <p class="text-[11px] leading-snug text-muted-foreground">{{ hint() }}</p>
    }
</div>